import { Device } from "callable-data-objects";
import { ConnectMapping } from "Components/Device/Flow/types";
import { Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { APIDeviceProps } from "Providers/types";
import React, { useEffect, useState } from "react";
import { Button, Form, Message } from "semantic-ui-react";

const DeleteForm = () => {
  const { devices, device, remove }: APIDeviceProps = useDevice();
  const [deleting, setDeleting] = useState<boolean>(false);
  const [canDelete, setCanDelete] = useState<boolean>(true);

  useEffect(() => {
    if (devices && device) {
      const found = devices.find((d: Device) => {
        return (
          new Device(d).connects
            .map((cm: ConnectMapping) => cm.connect)
            .indexOf(device.id) > -1
        );
      });
      setCanDelete(found === undefined);
    }
  }, [devices, device]);
  return (
    <Formik
      initialValues={{}}
      onSubmit={(values, actions) => {
        if (device) {
          setDeleting(true);
          remove(device.id);
        }
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          {!canDelete && (
            <Message color="blue">
              <Message.Header>Cannot Delete Device</Message.Header>
              <p>Device is currently connected</p>
            </Message>
          )}
          <Button color="red" type="submit" disabled={deleting || !canDelete}>
            Delete
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default DeleteForm;
